module.exports = __webpack_public_path__ + "static/media/specs.d140e2c0.svg";